import React from "react";
import kel from "../Assets/kel.png";
import kel2 from "../Assets/kel2.png";
import Element from "../Assets/Element.png";
import Resume from '../Assets/RESUME.pdf'

function About(props) {
  return (
    <div id="About">
      <div className="words">
        <section className="aboutheader">
          <hr className="aboutHr" /> ABOUT ME
        </section>
        <h1>
          I Can Give The Best <br /> That You Always Wanted
        </h1>

        <p>
          I enjoy building beautiful yet functional applications while paying a
          close attention to every requirement (design, performance, etc) that
          projects are expected to meet. I am a strong team player who strives
          well in a feedback-driven environment and as a life-long, quick
          learner I am ever ready to seize any available opportunity to broaden
          my knowledge-base.
        </p>
        <div className="pall">
          <div className="points">
            <div className="p">
              <div className="cir">
                <div className="dot"></div>
              </div>
            </div>
            <h4>Problem Solving</h4>
          </div>

          <div className="points">
            <div className="p">
              <div className="cir">
                <div className="dot"></div>
              </div>
            </div>
            <h4>Creative Idea</h4>
          </div>

          <div className="points">
            <div className="p">
              <div className="cir">
                <div className="dot"></div>
              </div>
            </div>
            <h4>High Quality</h4>
          </div>

          <div className="points">
            <div className="p">
              <div className="cir">
                <div className="dot"></div>
              </div>
            </div>
            <h4>Highly Motivated</h4>
          </div>
        </div>

        <div className="abtn">
          <button onClick={()=>window.location.assign("mailto:codingbakelvin@gmail.com")}>HIRE ME</button>
          <a href={Resume} target="_blank" rel="noreferrer" download>Download Resume </a>
        </div>
      </div>

      <div className="pho" data-aos="fade-right">
        <img src={kel2} alt="" />
        <img src={kel} alt="" />
      </div>

      <img id="e" src={Element} alt="" />
      <img id="e1" src={Element} alt="" />
      <img id="e2" src={Element} alt="" />
    </div>
  );
}

export default About;
